import './SideMenu.css';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import authService from '../linkto/authService';
import commonInterface from '../common/commonInterface';
import {parseDeviceToken} from '../common/TokenUtil';


export default function SideMenu({ isOpen, onClose, onClearComplete }) {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [isDebug, setIsDebug] = useState("N");

    useEffect(() => {
        const deviceTokenClaims = parseDeviceToken();
        setIsDebug( deviceTokenClaims && deviceTokenClaims.is_debug || "N");

        if (deviceTokenClaims && deviceTokenClaims.is_debug) {
            console.log('is_debug : ', deviceTokenClaims.is_debug );
            if (deviceTokenClaims.is_debug === "Y") {
                console.log('디버그 모드 활성화: 앱 데이터 삭제 기능이 메뉴에 표시됩니다.');
            } else {
                console.log('디버그 모드 비활성화: 앱 데이터 삭제 기능이 메뉴에 표시되지 않습니다.');
            }
        } else {
            console.log('디버그 모드 비활성화: 앱 데이터 삭제 기능이 메뉴에 표시되지 않습니다.');
        }

    }, [])
    
    const handleGuideClick = () => {
      onClose();
      navigate('/vtotp/guide')
    }
    const handleManualClick = () => {
      onClose();
      navigate('/vtotp/manual')
    }
    const handlePrivacyClick = () => {
      onClose();
      navigate('/vtotp/privacy-policy');
    };
    const handleAboutClick = () => {
      onClose();
      navigate('/vtotp/about')
    }
    const handleFileBoardClick = () => {
      onClose();
      navigate('/vtotp/file-board')
    }
    const handleSettingsClick = () => {
      onClose();
      authService.logout();
      navigate('/vtotp/settings');
    }
    const handleClearAppData = () => {
      onClose();
      const confirmed = window.confirm('앱 데이터를 모두 삭제하시겠습니까?\n이 작업은 되돌릴 수 없습니다.');
      if (!confirmed) return;
      commonInterface.clearAppData(function(result) {
        if (result === 'success') {
          commonInterface.showNativeToast('앱 데이터가 삭제되었습니다');
          if (onClearComplete) onClearComplete();
        } else {
          commonInterface.showNativeToast('삭제에 실패했습니다');
        }
      });
    }

    return (
        <>
            <div
                className={`side-menu-overlay ${isOpen ? 'open' : ''}`}
                onClick={onClose}
            />
            <div className={`side-menu ${isOpen ? 'open' : ''}`}>
                <div className="side-menu-header">
                    <span className="side-menu-title">{t('menu.title')}</span>
                    <button className="side-menu-close" onClick={onClose}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M18 6L6 18M6 6l12 12"/>
                        </svg>
                    </button>
                </div>
                <nav className="side-menu-nav">
                    <ul className="menu-group-info">
                        <li><button onClick={handleGuideClick}>{t('menu.guide')}</button></li>
                        <li><button onClick={handleManualClick}>{t('menu.manual')}</button></li>
                        <li><button onClick={handlePrivacyClick}>{t('menu.privacyPolicy')}</button></li>
                        <li><button onClick={handleAboutClick}>{t('menu.about')}</button></li>
                    </ul>
                    <ul className="menu-group-download">
                        <li><button onClick={handleFileBoardClick}>{t('menu.download')}</button></li>
                    </ul>
                    <ul className="menu-group-settings">
                        <li><button onClick={handleSettingsClick}>{t('menu.settings')}</button></li>
                    </ul>
                    {isDebug === "Y" && (
                        <ul className="menu-group-debug">
                            <li><button onClick={handleClearAppData}>앱 데이터 삭제</button></li>
                        </ul>
                    )}
                </nav>
            </div>
        </>
    );
}
